import React from 'react'

import historique from '../../Assets/Icons/historique.svg'
import panierIcon from '../../Assets/Icons/panier.svg'
import back from '../../Assets/Icons/back.svg'
import bart from '../../Assets/Logos/bart.svg'
import logout from '../../Assets/Icons/logout.svg'
import logoutBig from '../../Assets/Icons/logout_big.svg'

import './BasePage.scss'
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {StateModel} from "../../Models/StateModel";
import {OrderModel} from "../../Models/OrderModel";
import {UserModel} from "../../Models/UserModel";
import {setUser} from "../../store/actions";
import {useModal} from "../../hooks/useModal";
import Confirm from "../Confirm/Confirm";
import {StadiumModel} from "../../Models/StadiumModel";

interface BasePageProps {
    children: JSX.Element[] | JSX.Element
    showLogo?: boolean
    showHistorique?: boolean
    showPanier?: boolean,
    showBack?: boolean,
    title?: string,
    backDelta?: number,
    onBack?: () => void
    onLogout?: () => void
}

const BasePage: React.FC<BasePageProps> = ({children, showLogo, showBack, showHistorique, showPanier, title, backDelta = -1, onBack, onLogout}: BasePageProps) => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const panier = useSelector<StateModel, OrderModel | undefined>(state => state.panier)
    const stadium = useSelector<StateModel, StadiumModel | undefined>(state => state.stadium)
    const user = useSelector<StateModel, UserModel | undefined>(state => state.user)

    const confirmLogout = useModal()

    const handleLogout = () => {
        dispatch(setUser(undefined))
        confirmLogout.close()
        onLogout && onLogout()
    }

    return (
        <div className="page">
            <header className="page__header">
                {showLogo && <img src={stadium?.image || bart} alt="logo roland garros" className="page__header--logo" onClick={() => navigate('/')}/>}
                {showBack && <img src={back} alt="fleche retour" className="page__header--back" onClick={() => onBack ? onBack() : navigate(backDelta)}/>}
                {
                    title && <p className="page__header--title">{title}</p>
                }
                <div className="page__header__right">
                    {showHistorique && <img src={historique} alt="icone historique commandes" className="page__header__right--btn" onClick={() => navigate('/historique')}/>}
                    {showPanier && (
                        <div className="page__header__right--btn btnPanier" onClick={() => navigate('/panier')}>
                            <img src={panierIcon} alt="icone panier" className="btnPanier--icon"/>
                            {
                                panier?.orderProducts && panier.orderProducts.length > 0 && <div className="btnPanier--pastille" />
                            }
                        </div>
                    )
                    }
                    {user?.id && <img src={logout} alt="icone historique commandes" className="page__header__right--btn" onClick={confirmLogout.open}/>}
                </div>
            </header>
            <div className="page__content">
                {children}
            </div>
            <Confirm
                visible={confirmLogout.visible}
                title="Déconnexion"
                subTitle="Êtes vous sûr de vouloir vous déconnecter ?"
                icon={logoutBig}
                onOk={handleLogout}
                onCancel={confirmLogout.close}
                />
        </div>
    )
}

export default BasePage;
